import { FC, useState } from 'react';

import { IDictionaryItem } from 'api/types';
import { useDisclosure } from 'hooks';
import FilterButton from 'portfolio3/components/common/buttons/FilterButton';
import { MobileActionsDrawer } from 'portfolio3/components/drawers';
import { RadioGroupControl, RadioGroupController } from 'portfolio3/components/forms/RadioGroupControl';

interface IPersonalDiagnosticListMobileFilterProps {
  currentSubject: IDictionaryItem | null;
  subjectOptions: IDictionaryItem[];
  setCurrentSubject: (value: IDictionaryItem | null) => void;
}

const PersonalDiagnosticListMobileFilter: FC<IPersonalDiagnosticListMobileFilterProps> = ({
  currentSubject,
  subjectOptions,
  setCurrentSubject,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [tempSubject, setTempSubject] = useState<IDictionaryItem | null>(currentSubject);

  const handleOpen = () => {
    setTempSubject(currentSubject);
    onOpen();
  };

  const resetFilters = () => {
    if (subjectOptions.length > 0) {
      setTempSubject(subjectOptions[0]);
    }
  };

  const applyFilters = () => {
    setCurrentSubject(tempSubject);
    onClose();
  };

  const tempSubjectController: RadioGroupController = {
    handleChange(code) {
      const option = subjectOptions.find((option) => option.code === code);
      setTempSubject(option ?? currentSubject);
    },
  };

  const isFilterApplied = currentSubject?.code !== subjectOptions[0]?.code;
  const isResetDisabled = tempSubject?.code === subjectOptions[0]?.code;

  return (
    <>
      <FilterButton onClick={handleOpen} withIndicator={isFilterApplied} />

      <MobileActionsDrawer
        open={isOpen}
        onClose={onClose}
        title="Фильтр пройденные индивидуальные диагностики"
        isResetDisabled={isResetDisabled}
        onReset={resetFilters}
        onApply={applyFilters}
      >
        <RadioGroupControl
          isMobile
          label="Предметы"
          value={tempSubject?.code}
          options={subjectOptions}
          controller={tempSubjectController}
        />
      </MobileActionsDrawer>
    </>
  );
};

export default PersonalDiagnosticListMobileFilter;
